<template>
  <div>
    <page-title title="Reset Password" />
    <b-row>
      <b-col>
        <b-alert variant="danger" :show="errors && errors.length > 0">
          <div v-for="error in errors">
            {{error}}
          </div>
        </b-alert>
        <b-form @submit.preventDefault="onReset">
          <b-form-group label="Password" label-for="password" description="This is your password for the NAB site, not the AAAAI site.">
            <b-form-input type="password" id="password" v-model="password" required placeholder="Password"></b-form-input>
          </b-form-group>
          <b-form-group label="Confirm Password" label-for="confirmPassword">
            <b-form-input type="password" id="confirmPassword" v-model="confirmPassword" required placeholder="Confirm Password"></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Reset Password</b-button>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import CrudOperationsMixin from './Common/CrudOperationsMixin.js'

export default {
  name: "ResetPassword",
  mixins: [CrudOperationsMixin],
  props: {},
  data() {
    return {
      errors: null,
      password: '',
      confirmPassword: ''
    };
  },
  methods: {
    onReset() {
      if (this.password != this.confirmPassword) {
        this.errors = ['Your password and confirmation do not match. Please try again.']
        return;
      }

      this.query('/graphql/public', {
        query: `
          mutation ($resetPassword: ResetPasswordInputOGT!) {
            resetPassword (resetPassword: $resetPassword) {
              applicationUser {
                id,
                userName,
                roles {
                  id,
                  type,
                  station {
                    id,
                    displayCity,
                    name
                  }
                }
              }
              roles,
              jwtToken
            }
          }`,
        variables: {
          'resetPassword': { 
            "applicationUserId": this.$route.query.applicationUserId,
            "token": this.$route.query.token,
            "password": this.password
          }
        }}, (data) => {
          if (data.resetPassword) {
            this.processAuthResponse(data.resetPassword);
          }
        }, (errors) => {
          this.errors = errors.map(x => x.message);
        }, 'Password Reset', 'Unable to Reset Password', 'Your password was successfully reset.');
    },
    processAuthResponse: function (authResponse) {
      axios.defaults.headers.common['Authorization'] = "Bearer " + authResponse.jwtToken;
      this.$root.$data.authenticatedUser.username = authResponse.applicationUser.userName;
      this.$root.$data.authenticatedUser.id = authResponse.applicationUser.id;
      this.$root.$data.authenticatedUser.roles = authResponse.roles;
      this.$root.$data.authenticatedUser.stationRoles = authResponse.applicationUser.roles;

      localStorage.setItem('jwt', authResponse.jwtToken);
      localStorage.setItem('username', authResponse.applicationUser.userName);
      localStorage.setItem('id', authResponse.applicationUser.id);
      localStorage.setItem('roles', JSON.stringify(authResponse.roles));
      localStorage.setItem('stationRoles', JSON.stringify(authResponse.applicationUser.roles));

      this.$router.push('/');
    },
  },
  mounted () {
  }
};
</script>